export default __webpack_public_path__ + "static/media/17.65f4cf14.svg";